<div class="viewport-1">
  <background></background>
  <div
    class="timeup-dialog"
    [@hideTimeupText]="hideTimeupText ? 'hide' : 'show'"
    (@hideTimeupText.done)="hideTimeupTextDoneHandler($event)"
  >
  </div>
</div>
